var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoM2 = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m43.5 61.75-29.52-.09c-2.272 0-4.118-1.799-4.118-4.012V20.852c0-2.213 1.846-4.012 4.117-4.012H41.52c2.272 0 4.117 1.799 4.117 4.012V60.25"
  }), React.createElement("path", {
    fill: color,
    d: "M45 22.75H10.5v-3l.75-1.5 2.31-.75h29.19l1.5.75.75 1.5v3ZM10.5 57.25V55h23.25v6.6H15.375c-1.805 0-4.125-1.35-4.125-1.35l-.75-.75v-2.25Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M45 22.75H10.5v-3l.75-1.5 2.31-.75h29.19l1.5.75.75 1.5v3ZM10.5 57.25V55h23.25v6.6H15.375c-1.805 0-4.125-1.35-4.125-1.35l-.75-.75v-2.25Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M33.75 61.66H13.98c-2.272 0-4.118-1.799-4.118-4.012V20.852c0-2.213 1.846-4.012 4.117-4.012H41.52c2.272 0 4.117 1.799 4.117 4.012v7.898M9.862 22.924h35.775"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.33 58.505h2.84"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.5 55h23.25"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m21 41.666 12.072-5.286M21 37.524 28.76 34"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m31.407 69.366 5.387-6.318V36.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.314l5.387 6.318"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m31.407 69.366 5.387-6.318V36.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.314l5.387 6.318"
  }), React.createElement("path", {
    fill: color,
    d: "M84.403 38.25H37.095v-2.417l.789-2.416 2.365-1.611h37.846l3.942.805 2.366 2.417v3.222Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m37.096 63.222-4.73 5.64h56.769l-3.943-5.64H37.096Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M31.52 69.343h58.462c.23 0 .407.195.407.429v1.316c0 1.239-.955 2.244-2.134 2.244H33.246c-1.178 0-2.134-1.005-2.134-2.244V69.78c0-.242.186-.429.408-.429v-.008Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M59.854 35.261h1.793"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M36.801 38.222h47.896M36.802 63.064h47.896"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M59.854 66.406h1.193M64.04 66.406h1.2M51.466 66.406h1.2M55.66 66.406h1.2M47.28 66.406h1.193M38.9 66.406h1.192M43.085 66.406h1.2M77.214 66.406h1.2M81.409 66.406h1.193M73.028 66.406h1.193"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M50.5 55.166 72.578 45.5M50.5 50.334l14.193-6.445"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m31.407 69.366 5.387-6.318V36.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.314l5.387 6.318"
  }));
};
export default SvgTamanhoM2;